<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    :title="modalTitle"
    @on-confirm="saveItem"
    @on-cancel="hide()"
    :okText="$t('Save')"
    :closeText="$t('Close')"
  >
    <v-card flat class="pa-4">
      <v-form class="mt-2">
        <v-card outlined class="mb-4 rounded-lg">
          <v-card-text class="pb-2">
            <v-radio-group
              v-model="restore"
              class="mt-0"
            >
              <v-radio
                v-bind:label="$t('RecoverPassword')"
                value="password"
                class="mb-2"
                color="primary"
              ></v-radio>
              <v-radio
                v-bind:label="$t('RestoreTwoFactorAuthentication')"
                value="device"
                color="primary"
              ></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card outlined class="rounded-lg">
          <v-card-text>
            <v-text-field
              v-bind:label="$t('Email')"
              v-model="email"
              maxlength="100"
              :counter="100"
              :error-messages="emailErrors"
              @input="$v.email.$touch()"
              @blur="$v.email.$touch()"
              outlined
              rounded
              prepend-inner-icon="mdi-email-outline"
              color="primary"
              class="mt-1"
            ></v-text-field>
          </v-card-text>
        </v-card>
      </v-form>
    </v-card>
  </base-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import Utils from '@/ecm/common/Utils';

import UserService from '@/services/UserService';

export default {
    name: 'RecoverModal',
    data() {
        return {
            modal: {
                title: this.$t('LoginProblems'),
                key: 'recoverModal',
            },
            open: false,
            email: '',
            restore: 'password',
        };
    },
    mixins: [validationMixin],
    validations: {
        email: { required },
    },
    computed: {
        modalInstance() {
            return this.$refs[this.modal.key];
        },
        modalTitle() {
            return this.modal.title;
        },
        emailErrors() {
            const errors = [];
            if (!this.$v.email.$dirty) return errors;
            !this.$v.email.required && errors.push(this.$t('RequiredField'));
            return errors;
        },
    },
    methods: {
        saveItem() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            this.modalInstance.progress(true);
            if (this.restore == 'password') {
                UserService.recoverPassword(this.email).then((resp) => {
                    if (resp) {
                        Utils.toast.success(this.$t('EmailSent'));
                    }
                });
            } else {
                UserService.recoverDevice(this.email).then((resp) => {
                    if (resp) {
                        Utils.toast.success(this.$t('EmailSent'));
                    }
                });
            }
            this.modalInstance.progress(false);
            this.hide();
        },
        new() {
            this.email = '';
            this.$v.$reset();
            this.show();
        },
        show() {
            this.open = true;
        },
        hide() {
            this.open = false;
        },
    },
};
</script>

<style scoped>
</style>